export default {"src":"/_next/static/media/clock-plus.45ee5392.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};